// section 12

// function moveToSelected(element) {

//   if (element == "next") {
//     var selected = $(".selected").next();
//   } else if (element == "prev") {
//     var selected = $(".selected").prev();
//   } else {
//     var selected = element;
//   }

//   var next = $(selected).next();
//   var prev = $(selected).prev();
//   var prevSecond = $(prev).prev();
//   var nextSecond = $(next).next();

//   $(selected).removeClass().addClass("selected");

//   $(prev).removeClass().addClass("prev");
//   $(next).removeClass().addClass("next");

//   $(nextSecond).removeClass().addClass("nextSecond");
//   $(prevSecond).removeClass().addClass("prevSecond");

//   // no limit
//   $(nextSecond).nextAll().removeClass().addClass('hideRight');
//   $(prevSecond).prevAll().removeClass().addClass('hideLeft');
// };

// // Just to test, remove onclick in <a> and put your link in href
// function FindPos(obj) {
//   const posElement = Array.from(obj.parentNode.children).indexOf(obj) + 1; //  JQuery : $('#carousel a').index(obj) + 1;
//   const nbElements = obj.parentNode.childElementCount; // with JQuery : $('#carousel a').length;
//   console.log( "Menu n°" + posElement + " on " + nbElements + " clicked (Class => " + obj.className + ")");
// };

// // Keyboard events
// $(document).keydown(function(e) {
//     switch(e.which) {
//       case 37: // Keyboard : left arrow
//         moveToSelected('prev');
//         break;

//       case 39: // Keyboard : right arrow
//         moveToSelected('next');
//         break;

//         default: return;
//     }
//     e.preventDefault();
// });

// // Mouse click
// $('#carousel a').click(function() {
//   moveToSelected($(this));
// });

// // Buttons events
// $('#prev').click(function() {
//   moveToSelected('prev');
// });

// $('#next').click(function() {
//   moveToSelected('next');
// });



// setion 10 accordian JS

var whiteimages = document.querySelectorAll(".white_box_data")[1];
var blackimages = document.querySelectorAll(".black_box_data")[1];

var whiteimageshtml = document.querySelectorAll(".white_box_data")[0].innerHTML;
var blackimageshtml = document.querySelectorAll(".black_box_data")[0].innerHTML;
document.querySelectorAll(".white_box_data")[0].innerHTML = whiteimages.innerHTML + whiteimageshtml;
document.querySelectorAll(".black_box_data")[0].innerHTML = blackimages.innerHTML + blackimageshtml;


whiteimages.innerHTML = "";
blackimages.innerHTML = "";

let questions = document.querySelectorAll(".faq_question");

questions.forEach((question) => {
  let icon = question.querySelector(".icon-shape");

  question.addEventListener("click", (event) => {
    const active = document.querySelector(".faq_question.active");
    const activeIcon = document.querySelector(".icon-shape.active");

    if (active && active !== question) {
      active.classList.toggle("active");
      activeIcon.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }

    question.classList.toggle("active");
    icon.classList.toggle("active");

    const answer = question.nextElementSibling;

    if (question.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = 0;
    }
  });
});

window.loop = 0;


function onleft() {
  var images = document.querySelectorAll(".white_box_data img");
  images.forEach(function (image) {
    image.style.opacity = '0'
  })
  images[window.loop] ? images[window.loop].style.opacity = '1' : "";
  window.loop++;
  if (images.length == window.loop) {
    window.loop = 0;
  }

  var images2 = document.querySelectorAll(".black_box_data img");
  images2.forEach(function (image) {
    image.style.opacity = '0'
  })
  images2[window.loop] ? images2[window.loop].style.opacity = '1' : "";
  window.loop++;
  if (images2.length == window.loop) {
    window.loop = 0;
  }
}

function onright() {
  var images = document.querySelectorAll(".white_box_data img");
  images.forEach(function (image) {
    image.style.opacity = '0'
  })
  images[window.loop] ? images[window.loop].style.opacity = '1' : "";
  window.loop--;
  if (window.loop == 0 || window.loop < 1) {
    window.loop = images.length - 1;
  }

  var images2 = document.querySelectorAll(".black_box_data img");
  images2.forEach(function (image) {
    image.style.opacity = '0'
  })
  images2[window.loop] ? images2[window.loop].style.opacity = '1' : "";
  window.loop--;
  if (window.loop == 0 || window.loop < 1) {
    window.loop = images2.length - 1;
  }
}

window.counts = 4;
window.start = 0;
let touchArea = document.querySelector(".new_page_sec6_all_items");
let output = document.getElementById("output");
//Initial mouse X and Y positions are 0
let mouseX,
  initialX = 0;
let mouseY,
  initialY = 0;
let isSwiped;
//Events for touch and mouse
let events = {
  mouse: {
    down: "mousedown",
    move: "mousemove",
    up: "mouseup",
  },
  touch: {
    down: "touchstart",
    move: "touchmove",
    up: "touchend",
  },
};
let deviceType = "";
//Detect touch device
const isTouchDevice = () => {
  try {
    //We try to create TouchEvent (it would fail for desktops and throw error)
    document.createEvent("TouchEvent");
    deviceType = "touch";
    return true;
  } catch (e) {
    deviceType = "mouse";
    return false;
  }
};
//Get left and top of touchArea
let rectLeft = touchArea.getBoundingClientRect().left;
let rectTop = touchArea.getBoundingClientRect().top;
//Get Exact X and Y position of mouse/touch
const getXY = (e) => {
  mouseX = (!isTouchDevice() ? e.pageX : e.touches[0].pageX) - rectLeft;
  mouseY = (!isTouchDevice() ? e.pageY : e.touches[0].pageY) - rectTop;
};
isTouchDevice();
//Start Swipe
touchArea.addEventListener(events[deviceType].down, (event) => {
  isSwiped = true;
  //Get X and Y Position
  getXY(event);
  initialX = mouseX;
  initialY = mouseY;
});
//Mousemove / touchmove

touchArea.addEventListener(events[deviceType].move, (event) => {
  if (!isTouchDevice()) {
    event.preventDefault();
  }
  if (isSwiped) {
    getXY(event);
    let diffX = mouseX - initialX;
    let diffY = mouseY - initialY;
    if (Math.abs(diffY) > Math.abs(diffX)) {
      // output.innerText = diffY > 0 ? "Down" : "Up";
    } else {
      window.start = window.start + 1;
      if (window.start == window.counts) {
        diffX > 0 ? onright() : onleft();
        window.start = 0;
      }
    }
  }
});
//Stop Drawing
touchArea.addEventListener(events[deviceType].up, () => {
  isSwiped = false;
});
touchArea.addEventListener("mouseleave", () => {
  isSwiped = false;
});
window.onload = () => {
  isSwiped = false;
};


//  all section swiiper js 

class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.querySelector('script').innerHTML);
  }
  connectedCallback() {
    this.swiper = new Swiper(this, this.config);
  }
  disconnectedCallback() {
    this.swiper.destroy(true, true);
  }
}

customElements.define('swiper-slider', SwiperSlider);

class SwiperSliderMobile extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.querySelector('script').innerHTML);
  }
  connectedCallback() {
    if (window.innerWidth < 768) {
      this.swiper = new Swiper(this, this.config);
    }

  }
  disconnectedCallback() {
    this.swiper.destroy(true, true);
  }
}

customElements.define('main-swiper', SwiperSliderMobile);


// section 7

document.addEventListener('DOMContentLoaded', function () {
  const boxes = document.querySelectorAll('.box');
  const playButtons = document.querySelectorAll('.new_page_sec7_play_button');
  boxes[0].classList.add('active');
  playButtons[0].classList.add('active');
  function deactivateAll() {
    boxes.forEach(function (box) {
      box.classList.remove('active');
    });
    playButtons.forEach(function (playButton) {
      playButton.classList.remove('active');
    });
  }
  boxes.forEach(function (box, index) {
    box.addEventListener('click', function () {
      deactivateAll();
      this.classList.add('active');
      playButtons[index].classList.add('active');
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.new_page_sec7_play_button');
  const videos = document.querySelectorAll('.new_page_sec7_item_video');
  buttons.forEach(function (button, index) {
    button.addEventListener('click', function () {
      videos[index].classList.toggle('start');
      document.querySelectorAll(".new_page_sec7_item_video").forEach(function (video) {
        video.querySelector("video").pause();
        video.classList.remove("start")
      })

      this.parentElement.querySelector("video").play()
      var elem = this.parentElement.querySelector("video");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
      }


      this.parentElement.querySelector(".new_page_sec7_item_video").classList.add("start")
    });
  });
});

document.querySelectorAll(".new_page_sec7_item_video video").forEach(function (video) {
  video.addEventListener("pause", function () {
    this.parentElement.classList.remove("start")
  });
})


// section 6

document.addEventListener('DOMContentLoaded', function () {
  const firstButton = document.querySelector('.white_btn');
  const secondButton = document.querySelector('.black_btn');
  const firstBox = document.querySelector('.white_box_data');
  const secondBox = document.querySelector('.black_box_data');

  secondBox.style.display = 'none'
  // Function to show only one box
  function showOnlyOneBox(boxToShow) {
    if (boxToShow === 'white') {
      firstBox.style.display = 'block';
      secondBox.style.display = 'none';
    } else if (boxToShow === 'black') {
      firstBox.style.display = 'none';
      secondBox.style.display = 'block';
    }
  }

  // Initially hide one of the boxes using CSS

  // Check the initial state and show only one box
  const isFirstBoxVisible = window.getComputedStyle(firstBox).display !== 'none';
  const isSecondBoxVisible = window.getComputedStyle(secondBox).display !== 'none';

  if (isFirstBoxVisible && !isSecondBoxVisible) {
    showOnlyOneBox('white');
  } else if (!isFirstBoxVisible && isSecondBoxVisible) {
    showOnlyOneBox('black');
  }

  // Add event listeners to the buttons
  firstButton.addEventListener('click', function () {
    showOnlyOneBox('white');
  });

  secondButton.addEventListener('click', function () {
    showOnlyOneBox('black');
  });
});

function changemainimage(id) {
  document.querySelectorAll(".main_swipper_sec3_item").forEach(function (img, index) {
    if (img.getAttribute("data-image-id") == id) {
      document.querySelectorAll(".new_page_sec3_items .swiper-pagination-bullet")[index].click()

    }
  })
}


function changemaster() {
  var master = document.querySelectorAll("#masterselect option");

  var selected = document.querySelectorAll(".variant-swatch-option:checked");
  var variantname = '';

  for (let i = 0; i < selected.length; i++) {
    const element = selected[i].value;
    if (i == selected.length - 1) {
      variantname = variantname + element;
    }
    else {
      variantname = variantname + element + ' / ';
    }
  }

  var choosen = false;
  var available = false;
  var id = "";
  var price = "";
  var compareprice = "";
  for (let j = 0; j < master.length; j++) {
    const element = master[j].getAttribute("data-index");
    if (element == variantname) {
      id = master[j].getAttribute("value");
      document.querySelector("#masterselect").value = id;
      price = master[j].getAttribute("data-price");
      compareprice = master[j].getAttribute("data-compareprice");
      var choosen = true;
      available = master[j].getAttribute("data-available");
      document.querySelector(".product_price_buy").textContent = price;
      document.querySelector(".product_compareprice_buy").textContent = compareprice;
      changemainimage(master[j].getAttribute("data-image-id"))
    }
  }

  var availabletext = document.querySelector("#masterselect").getAttribute("data-available-text");
  var soldouttext = document.querySelector("#masterselect").getAttribute("data-solout-text");
  var unavailabletext = document.querySelector("#masterselect").getAttribute("data-unavailable-text");

  if (choosen) {
    if (available == "true") {
      document.querySelector(".addtocart_btn").textContent = availabletext;
      document.querySelector(".addtocart_btn").removeAttribute("disabled");
    }
    else if (available == "false") {
      document.querySelector(".addtocart_btn").textContent = soldouttext;
      document.querySelector(".addtocart_btn").setAttribute("disabled", "disabled");
    }
  }
  else {
    document.querySelector(".addtocart_btn").textContent = unavailabletext;
    document.querySelector(".addtocart_btn").setAttribute("disabled", "disabled")
  }

  // var nextURL = window.location.pathname + "?variant=" + id;
  // window.history.replaceState("", "", nextURL);
}

// section 12



